// Bowlscout version of table container component

import { TableContainer } from '@mui/material';

const BSTableContainer = ({ children, sx }) => {
  return (
    <TableContainer
      sx={{
        width: '100%',
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: 'none',
        borderRadius: 2,
        backgroundColor: (theme) => theme.palette.background.paper,
        overflow: 'hidden',
        ...sx
      }}>
      {children}
    </TableContainer>
  );
};

export default BSTableContainer;
